export default __webpack_public_path__ + "static/media/0007ROUGE.ddae2d3d.pdf";